<template>
  <div>
    <v-btn large>Preview</v-btn>
  </div>
</template>

<script>
export default {
  name: "PreviewButton"
};
</script>

<style lang="scss" scoped>
@import "src/assets/css/variables.scss";
.theme--light.v-btn:not(.v-btn--flat):not(.v-btn--text):not(.v-btn--outlined) {
  color: black;
  display: block;
  border-radius: 20px;
  width: $width-button;
  border: 1px solid $submit-color;
  margin: $margin-button;
  height: $height-button;
}
</style>
